/*
 *
 * RefoundUnavailable
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 19-Mar-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import './RefoundUnavailable.scss'

const RefoundUnavailable = (props) => {
  const { userType } = props
  const isUserTypeAllowed = (userType) => userType === 'CF_ISP_CONTACTS_NOT_CERTIFIED' || userType === 'CF_NOT_ISP'

  const messageMap = {
    title: isUserTypeAllowed(userType) ? formattedMessage[userType].title : '',
    description: isUserTypeAllowed(userType) ? formattedMessage[userType].description : '',
    primaryButtonLabel: isUserTypeAllowed(userType) ? formattedMessage[userType].primaryButtonLabel : '',
    secondaryButtonLabel: isUserTypeAllowed(userType) ? formattedMessage[userType].secondaryButtonLabel : ''
  }

  const onClose = () => {
    props.actions.doHideTtl()
    props.actions.doRetrieveTTL()
  }

  return (
    <Toggle>
      {userType === 'CF_ISP_CONTACTS_NOT_CERTIFIED' && (
        <MerchantModal
          title={messageMap.title}
          description={messageMap.description}
          onClose={() => onClose()}
          primaryButtonLabel={messageMap.primaryButtonLabel}
          primaryAction={() => onClose()}
        />
      )}
      {userType === 'CF_NOT_ISP' && (
        <MerchantModal
          title={messageMap.title}
          description={messageMap.description}
          onClose={() => onClose()}
          primaryButtonLabel={messageMap.primaryButtonLabel}
          primaryAction={() => onClose()}
        />
      )}

    </Toggle>
  )
}

RefoundUnavailable.propTypes = {
  actions: PropTypes.object,
  userType: PropTypes.string
}

RefoundUnavailable.defaultProps = {
  actions: {},
  userType: ''
}

export default RefoundUnavailable
